export const BLITZ_SPECIFIC_LINKS = {
  galxe: 'https://galxe.com/Untv4CWb4bpdfzajsDq9aA/campaign/GCyc1t4byf',
  bridge: 'https://blast.io/en/bridge',
  blastAirdropPoints: 'https://blast.io/en/airdrop',
  blastPhase2Details: 'https://blog.blast.io/phase-2-users/',
  pointsProgramDocs:
    'https://docs.blitz.exchange/points-and-protocol-rewards/blitz-points-program',
  pointsEpochSchedule:
    'https://medium.com/@blitz_exchange/rewards-phase-2-gold-distribution-1-new-epoch-weights-opportunities-1bfe7e310e52',
  blitzBlog: 'https://medium.com/@blitz_exchange',
  tradingCompetitionDocs:
    'https://docs.blitz.exchange/rewards/trading-competition',
};

export const BLITZ_COMMON_LINKS = {
  // Blitz betteruptime uses the same link as Vertex
  appStatus: 'https://vertex.betteruptime.com',
  cookiePolicy: 'https://blitz.exchange/docs/CookiePolicy.pdf',
  crossChainDocs: 'https://docs.blitz.exchange/tutorials/cross-chain-deposits',
  discord: 'https://discord.gg/blitzexchange',
  docs: 'https://docs.blitz.exchange/',
  faq: 'https://docs.blitz.exchange/basics/faqs',
  fastWithdrawalsLearnMore: `https://docs.blitz.exchange/tutorials/fast-withdrawals`,
  hacken: 'https://hackenproof.com/company/vertex-protocol/programs',
  // Blitz hacken uses the same link as Vertex
  isolatedDocs: 'https://docs.blitz.exchange/basics/isolated-margin',
  lpDocs: 'https://docs.blitz.exchange/basics/blitz-dex-technical-stack',
  maintenanceWindowDocs:
    'https://docs.blitz.exchange/resources-and-links/maintenance-windows-and-status',
  marketingSite: 'https://blitz.exchange',
  multipleSubaccountsDocs:
    'https://docs.blitz.exchange/tutorials/multiple-accounts',
  privacyPolicy: 'https://blitz.exchange/docs/PrivacyPolicy.pdf',
  // Referral page is Vertex specific for now, but leaving this here until there is referral docs for Blitz
  referralDocs:
    'https://vertex-protocol.gitbook.io/docs/community-token-and-dao/referrals',
  spotTradingLearnMore: 'https://docs.blitz.exchange/tutorials/spot-trading',
  spreadDocs:
    'https://docs.blitz.exchange/basics/subaccounts-isolated-margin-and-health#special-cases-spreads-lps-and-large-positions',
  termsOfUse: 'https://blitz.exchange/docs/TermsOfUse.pdf',
  tutorials: 'https://docs.blitz.exchange/tutorials/getting-started',
  twitter: 'https://twitter.com/tradeonblitz',
};
